import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./profile1.css";
import Rating from "react-rating";
import { Urls } from "../../../../Urls";
import axios from "../../../../Axios";
import Loader from "../../../Loader";
import classes from "./Profile.module.css";
import { getImageSrc, imageFallBack } from "../../../../Utility";
import PopupModal from "../../../Shared/PopupModal/PopupModal";
import {
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  WhatsappIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share";
import {
  Activity,
  DateFormatter4,
  currentRequestTimeStamp,
} from "../../../../Constants";
import Sendenquirynew from "./Sendenquirynew";
import Modal from "../../../Shared/PopupModal/PopupModal";
import { DownloadFile } from "../../../../utils/downloadFile";
import BrochureContent from "./BrochureModal";

let logo_ext = [];

const Profile = ({ transporter_data: initialData }) => {
  const [state, setState] = useState({
    initialrating: 0,
    shortlisted: "no",
    status: false,
    message: "",
    brochureOpen: true,
    profile: "#",
    sharePopUp: false,
    logo: "",
    profile_view: 0,
  });

  const [transporterData, setTransporterData] = useState(initialData);
  const [streamingData, setStreamingData] = useState([]);
  const [metadata, setMetadata] = useState({
    transporter_name: "Transporter_name",
    company_type: "company_type",
    headquarter: "headquarter",
    established: "established",
    overall_rating: 0,
    number_of_ratings: 0,
    website: "",
    last_updated: null,
    profile: "#",
  });
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    if (!initialData || Object.keys(initialData).length === 0) return;

    setTransporterData(initialData);
    sessionStorage.setItem(
      "contactInfo",
      JSON.stringify(initialData.contact_information),
    );
    sessionStorage.setItem(
      "transporterName",
      JSON.stringify(initialData.transporter_name),
    );

    const sData = initialData.streaming_data_input || [];
    setStreamingData(sData);

    Activity([
      {
        screen: "TPMP Client",
        module: "TPMP Client",
        user_activity: `${initialData.transporter_name} profile viewed`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    const rating =
      initialData.overall_rating !== null &&
      initialData.overall_rating !== undefined
        ? initialData.overall_rating
        : 0;
    const numRatings =
      initialData.number_of_ratings !== null &&
      initialData.number_of_ratings !== undefined
        ? initialData.number_of_ratings
        : 0;

    const logo =
      initialData.logo && initialData.logo !== "" ? initialData.logo : "";

    const website =
      initialData.website && initialData.website !== ""
        ? initialData.website
        : "";

    const profile =
      initialData.attachments &&
      initialData.attachments[0]?.blob_url &&
      initialData.attachments[0].blob_url !== ""
        ? initialData.attachments[0].blob_url
        : "#";

    const transporter_name = initialData.transporter_name || "Transporter_name";
    const company_type = initialData.company_type || "";
    const headquarter = initialData.headquarter || "";
    const established = initialData.established || "";
    const last_updated = initialData.last_updated || null;
    const shortlisted = initialData.shortlisted || "no";

    logo_ext = logo.split(".");

    setMetadata({
      transporter_name,
      company_type,
      headquarter,
      established,
      overall_rating: rating,
      number_of_ratings: numRatings,
      website,
      last_updated,
      profile,
    });

    setState((prev) => ({
      ...prev,
      shortlisted,
      logo,
      profile,
      profile_view: initialData.profile_views,
    }));
  }, [initialData]);

  const referenceCheck = () => {
    Activity([
      {
        screen: "TPMP Client",
        module: "TPMP Client",
        user_activity: `${metadata.transporter_name} reference check requested`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    setState({
      ...state,
      status: true,
      message: "Submitting Reference Check request",
    });

    axios
      .post(Urls.Transporters.SendgridEmail, {
        subject: `Reference Check Request for ${metadata.transporter_name}`,
        to_email: "connect@logisticsnow.in",
        content: `Reference Check for Transporter has been made by ${localStorage.getItem(
          "userdetails",
        )}`,
      })
      .then(() => {
        toast.success("Reference Check Submitted Successfully");
        setState({ ...state, status: false });
      })
      .catch(() => {
        setState({ ...state, status: false });
      });
  };

  const openWebsite = () => {
    let { website } = metadata;
    Activity([
      {
        screen: "TPMP Client",
        module: "TPMP Client",
        user_activity: `${metadata.transporter_name} website clicked`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    if (website.split(".")[0] === "www") website = `http://${website}`;
    if (!website.includes("http")) website = `http://${website}`;
    window.open(website, "_blank");
  };

  const toggleShortlist = () => {
    if (state.shortlisted === "no") {
      setState({ ...state, status: true, message: "Shortlisting Transporter" });
      Activity([
        {
          screen: "TPMP Client",
          module: "TPMP Client",
          user_activity: `${metadata.transporter_name} shortlisted`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      axios
        .post(Urls.Transporters.Shortlist, {
          shortlists: [
            {
              transporter_id: transporterData.transporter_id,
              transporter_name: transporterData.transporter_name,
            },
          ],
        })
        .then(() => {
          toast.success("Transporter Shortlisted Successfully");
          setState({ ...state, shortlisted: "yes", status: false });
        })
        .catch(() => setState({ ...state, status: false }));
    } else {
      setState({ ...state, status: true, message: "Removing From Shortlist" });
      Activity([
        {
          screen: "TPMP Client",
          module: "TPMP Client",
          user_activity: `${metadata.transporter_name} removed from shortlist`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      axios
        .delete(Urls.Transporters.Shortlist, {
          data: {
            shortlists: [
              {
                transporter_id: transporterData.transporter_id,
                transporter_name: transporterData.transporter_name,
              },
            ],
          },
        })
        .then(() => {
          toast.success("Transporter Removed from shortlist");
          setState({ ...state, shortlisted: "no", status: false });
        })
        .catch(() => setState({ ...state, status: false }));
    }
  };

  const copyLink = () => {
    Activity([
      {
        screen: "TPMP Client",
        module: "TPMP Client",
        user_activity: `${metadata.transporter_name} share link copied`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    const copyText = document.getElementById("profileLinkCode");
    if (copyText) {
      navigator.clipboard
        .writeText(copyText.value)
        .then(() => toast.success("Profile link copied"))
        .catch((err) => console.error("Failed to copy: ", err));
    }
  };

  const findNameByContactNumber = (contactNumber) => {
    const contactInfo = transporterData.contact_information || [];
    const foundContact = contactInfo.find(
      (contact) => contact.contact_number === contactNumber,
    );
    return foundContact ? foundContact.name : "";
  };

  const Trucks_Available = () => {
    return (
      <>
        {window.innerWidth > 600 ? (
          <div className="s-overflow">
            <table className="table table-striped table-borderless">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Posted On</th>
                  <th style={{ textAlign: "center" }}>
                    Location at which truck(s) available
                  </th>
                  <th style={{ textAlign: "center" }}>
                    Number of trucks available with driver
                  </th>
                  <th style={{ textAlign: "center" }}>Truck type</th>
                  <th style={{ textAlign: "center" }}>Preferred destination</th>
                </tr>
              </thead>
              <tbody>
                {streamingData.length > 0 ? (
                  streamingData.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">
                        {item.timestamp ? DateFormatter4(item.timestamp) : " "}
                      </th>
                      <td>
                        {item.origin?.label ||
                          `${item.origin.location_name}, ${item.origin.district}, ${item.origin.state}`}
                      </td>
                      <td>{item.available_trucks || 0}</td>
                      <td>
                        {item.truck_type?.map((truck, ti) => (
                          <div key={ti}>{truck.value}</div>
                        ))}
                      </td>
                      <td>
                        {item.destination?.map((dest, di) => (
                          <div key={di}>{dest.location_name}</div>
                        ))}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">Details not available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="panel-group" id="panels">
            {streamingData.length > 0 ? (
              streamingData.map((item, index) => (
                <div key={index} className="panel panel-default">
                  <center>
                    <h4>
                      <b>
                        {item.origin?.location_name || " "}
                        <i className="fa fa-angle-down"></i>
                      </b>
                    </h4>
                  </center>
                </div>
              ))
            ) : (
              <div className="s-center">
                <span className="s-d">Details not available</span>
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  if (!transporterData) {
    return (
      <div className="container">
        <span className="data_header">Profile Information</span>
        <p>Details not available</p>
      </div>
    );
  }

  return (
    <div className="container Profile_container">
      <div className="card1">
        <div className="card-header1">
          <img
            alt="profile_logo"
            id="profile_logo_screen"
            src={getImageSrc(state.logo)}
            onError={(e) => imageFallBack(e)}
            className="profile-img"
          />
        </div>

        <div className="card-body1">
          {transporterData.hand_over_status === true ? (
            <>
              <span className="full-name">{metadata.transporter_name}</span>
              <i
                style={{
                  color: "#54af3a",
                  fontSize: "21px",
                  marginLeft: "2%",
                }}
                title="Profile managed by LSP"
                className="fas fa-check-circle"
              ></i>
            </>
          ) : (
            <>
              <span className="full-name">{metadata.transporter_name}</span>
              <br />
            </>
          )}

          <div className="row" style={{ margin: "3% 3%", fontSize: "14px" }}>
            <div className="col-6 s-col">
              <center>
                <Rating
                  style={{ width: "102%" }}
                  emptySymbol="fa fa-star-o fa-2x mystar"
                  fullSymbol="fa fa-star mystar"
                  readonly={true}
                  fractions="4"
                  initialRating={metadata.overall_rating}
                />
                <br />
                {metadata.number_of_ratings === 0
                  ? ""
                  : `(${metadata.number_of_ratings} Ratings)`}
              </center>
            </div>

            <div className="col-6 s-max">
              <center>
                <span title="Profile Views">
                  <b className={classes["profile_count"]}>
                    {state.profile_view}
                  </b>
                  <br /> Profile Views
                </span>
              </center>
            </div>
          </div>

          {/* Website + Brochure */}
          <span className="username">
            {!metadata.website ? (
              state.profile === "#" ? (
                ""
              ) : (
                <>
                  <button
                    style={{
                      border: "none",
                      color: "#337ab7",
                      backgroundColor: "white",
                    }}
                    onClick={openWebsite}
                  >
                    <i className="fa fa-globe"></i> Website
                  </button>
                  {/* <button
                    className="username"
                    style={{
                      textDecoration: "none",
                      color: "#337ab7",
                      border: "none",
                      backgroundColor: "white",
                    }}
                  >
                    <i className="fa fa-file-text-o"></i> Brochure222
                  </button> */}

                  <PopupModal
                    buttonLabel={
                      <span
                        style={{
                          textDecoration: "none",
                          color: "#337ab7",
                        }}
                      >
                        <i className="fa fa-file-text-o"></i> Brochure
                      </span>
                    }
                    buttonClass="btn-link username text-decoration-none"
                    title="Brochure"
                    closeButtonId="close_profile_brochure"
                    content={
                      <BrochureContent
                        attachment={initialData.attachments?.[0]}
                      />
                    }
                    size="md"
                    backdrop={true}
                  />
                </>
              )
            ) : (
              <>
                {state.profile !== "#" && (
                  <>
                    <button
                      style={{
                        border: "none",
                        color: "#337ab7",
                        backgroundColor: "white",
                      }}
                      onClick={openWebsite}
                    >
                      <i className="fa fa-globe"></i> Website
                    </button>
                    <Modal
                      buttonLabel={
                        <span
                          style={{
                            textDecoration: "none",
                            color: "#337ab7",
                          }}
                        >
                          <i className="fa fa-file-text-o"></i> Brochure
                        </span>
                      }
                      buttonClass="btn-link username text-decoration-none"
                      content={
                        <BrochureContent
                          attachment={initialData.attachments?.[0]}
                        />
                      }
                      title="Brochure"
                      id="closebutton"
                      size="lg"
                      screenName="Transporter profile"
                      moduleName="Brochure"
                      closebuttonclass={classes["close-button"]}
                      activityName="Brochure Viewed"
                      backdrop={false}
                    />
                  </>
                )}
              </>
            )}
          </span>

          <br />
          <span className="username">
            {!metadata.company_type ? (
              !metadata.established ? (
                ""
              ) : (
                <>Est. {metadata.established}</>
              )
            ) : (
              <>
                {metadata.company_type.charAt(0).toUpperCase() +
                  metadata.company_type.substring(1)}{" "}
                {!metadata.established ? "" : `| Est. ${metadata.established}`}
              </>
            )}
            <br />
          </span>

          <span className="username">
            {!transporterData.experience_year
              ? ""
              : transporterData.experience_year === 0
                ? "1 < Years of experience"
                : `${transporterData.experience_year} Years of Experience`}
            <br />
          </span>

          <span className="username">
            {!metadata.headquarter ? (
              ""
            ) : (
              <>
                HQ: {metadata.headquarter} <br />
                <br />
              </>
            )}
          </span>

          {/* Action Buttons */}
          <div className="container position-relative">
            <div>
              <center>
                {state.shortlisted === "no" ? (
                  <button
                    style={{ backgroundColor: "#393185" }}
                    title="Shortlist LSP"
                    type="button"
                    id="shortlist"
                    className="ripple button1"
                    onClick={toggleShortlist}
                  >
                    <i className="fa fa-user-plus"></i> Shortlist
                  </button>
                ) : (
                  <button
                    style={{ backgroundColor: "#54af3a" }}
                    title="Shortlist LSP"
                    type="button"
                    id="shortlist"
                    className="ripple button12"
                    onClick={toggleShortlist}
                  >
                    <i className="fa fa-user-plus"></i> Shortlisted
                  </button>
                )}

                <button
                  style={{ backgroundColor: "#393185" }}
                  className="ripple button1"
                  title="Request Reference checks"
                  onClick={referenceCheck}
                >
                  <i className="fa fa-clipboard-check"></i> Reference check
                </button>
              </center>

              <center className="s-margin-top">
                <button
                  style={{ backgroundColor: "#393185" }}
                  className="ripple button1"
                  title="Share Profile"
                  onClick={() => setShareOpen((prev) => !prev)}
                  id="shareDropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-share-alt"></i> Share
                </button>

                {shareOpen && (
                  <div
                    className={`dropdown-menu  ${classes["user-profile-popup"]}`}
                    style={{
                      marginLeft: "20%",
                      display: "block",
                      position: "absolute",
                      zIndex: 9999,
                    }}
                    aria-labelledby="shareDropdown"
                  >
                    <div className={classes["link_text_copy"]}>
                      <input
                        style={{ width: "80%" }}
                        id="profileLinkCode"
                        value={`https://portal.lorri.in/profile/${transporterData.profile_code}`}
                        readOnly
                      />
                      <i
                        style={{ cursor: "pointer" }}
                        title="Copy Link"
                        className="fa fa-copy"
                        onClick={copyLink}
                      />
                    </div>

                    <span className="d-flex flex-row justify-content-around align-items-center">
                      <WhatsappShareButton
                        title={`View LoRRI profile of ${transporterData.transporter_name}`}
                        url={`https://portal.lorri.in/profile/${transporterData.profile_code}`}
                      >
                        <WhatsappIcon size={32} round />
                      </WhatsappShareButton>

                      <LinkedinShareButton
                        url={`https://portal.lorri.in/profile/${transporterData.profile_code}`}
                      >
                        <LinkedinIcon size={32} round />
                      </LinkedinShareButton>

                      <EmailShareButton
                        subject="I am sharing LoRRI Profile with you!"
                        body={`Hi, I am sharing LoRRI Profile of ${transporterData.transporter_name}. You can view it here:`}
                        url={`https://portal.lorri.in/profile/${transporterData.profile_code}`}
                      >
                        <EmailIcon size={32} round />
                      </EmailShareButton>
                    </span>
                  </div>
                )}
              </center>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer1 container" style={{ padding: "2%" }}>
          <div>
            <center>
              <Modal
                buttonLabel={"SEND LOGISTICS ENQUIRY"}
                buttonClass={`${classes["s-button"]} ripple button1`}
                content={<Sendenquirynew transporter={transporterData} />}
                title="SEND LOGISTICS ENQUIRY"
                id="closebutton"
                size="md"
                screenName="Transporter profile"
                moduleName="Send Logistics Enquiry"
                closebuttonclass={classes["close-button"]}
                activityName="Send Logistics Enquiry Clicked"
                backdrop={false}
              />
              <Modal
                buttonLabel={"TRUCKS AVAILABLE NOW!"}
                buttonClass={`${classes["s-truck-button"]} ripple button1`}
                content={Trucks_Available()}
                title="TRUCKS AVAILABLE NOW!"
                id="closebutton"
                size="lg"
                screenName="Transporter profile"
                moduleName="Send Logistics Enquiry"
                closebuttonclass={classes["close-button"]}
                activityName="Send Logistics Enquiry Clicked"
                backdrop={false}
                style={{ fontSize: "13px" }}
                overflowStyles={{ overflowY: "hidden" }}
              />
            </center>
          </div>

          <div>
            <center>
              {metadata.last_updated ? (
                <>
                  {transporterData.last_updated_by?.length > 0 && (
                    <>
                      <span className="s-profile">
                        Profile Last Updated by{" "}
                        {transporterData.last_updated_by[
                          transporterData.last_updated_by.length - 1
                        ]?.name
                          ? transporterData.last_updated_by[
                              transporterData.last_updated_by.length - 1
                            ].name
                          : findNameByContactNumber(
                              transporterData.last_updated_by[
                                transporterData.last_updated_by.length - 1
                              ]?.contact_number
                                ? transporterData.last_updated_by[
                                    transporterData.last_updated_by.length - 1
                                  ]?.contact_number
                                : "LSP",
                            )}{" "}
                        on{" "}
                        {new Date(
                          transporterData.last_updated_by[
                            transporterData.last_updated_by.length - 1
                          ].timestamp.includes("T")
                            ? transporterData.last_updated_by[
                                transporterData.last_updated_by.length - 1
                              ].timestamp
                            : transporterData.last_updated_by[
                                transporterData.last_updated_by.length - 1
                              ].timestamp
                                .replace(" ", "T")
                                .split(".")[0] + "Z", // remove microseconds
                        ).toLocaleString("en-IN", {
                          timeZone: "Asia/Kolkata",
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          //second: "2-digit",
                          hour12: true,
                        })}
                      </span>
                      <br />
                      <span className="s-profile">
                        <i
                          style={{ color: "#54af3a", fontSize: "21px" }}
                          title="Profile managed by LSP"
                          className="fas fa-check-circle"
                        ></i>
                        Profile managed by LSP
                      </span>
                    </>
                  )}
                </>
              ) : (
                <>
                  <span className="s-profile">
                    Profile Last Updated - <i>Not Available</i>
                  </span>
                  <br />
                </>
              )}
            </center>
          </div>
        </div>
      </div>

      <Loader show={state.status} message={state.message} />
    </div>
  );
};

export default Profile;
